// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"2cd94555","703":"a5bb9233"}[chunkId] + ".chunk.js";
};